import type { LiquidSettingsContextProviderValue } from "@components/Liquid/LiquidSettingsContext/types";

import type { InsertionWithOptions } from "../types";

export const monacoHtmlEditorShapeFromContext = ({
  allowedLiquidOptions: options,
  dispatchPropertyAllowedInCampaignProperties,
  customAutocompleteSnippets,
}: LiquidSettingsContextProviderValue): InsertionWithOptions => ({
  emailProperties: options.includes("EMAIL_PROPERTIES"),
  campaignProperties: options.includes("CAMPAIGN_PROPERTIES"),
  workflowProperties: options.includes("WORKFLOW_PROPERTIES"),
  contextProperties: options.includes("CONTEXT_PROPERTIES"),
  eventProperties: options.includes("EVENT_PROPERTIES"),
  smsProperties: options.includes("SMS_PROPERTIES"),
  whatsAppProperties: options.includes("WHATS_APP_PROPERTIES"),
  catalogItems: options.includes("CATALOG_ITEMS"),
  productRecommendation: options.includes("PRODUCT_RECOMMENDATION"),
  preferenceCenter: options.includes("PREFERENCE_CENTER"),
  cardProperties: options.includes("CARD_PROPERTIES"),
  targetedDeviceProperties: options.includes("TARGETED_DEVICE_ATTRIBUTES"),
  connectedContent: options.includes("CONNECTED_CONTENT"),
  vouchers: options.includes("VOUCHER"),
  noDispatchIdProperty: !dispatchPropertyAllowedInCampaignProperties,
  translation: options.includes("TRANSLATION"),
  customAutocompleteSnippets,
});
